exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-ext.js
// module id = 72
// module chunks = 168707334958949